import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Card, CardContent } from '@mui/material';
import { signInRequest } from '../../../redux/ducks/UserDucks';

import { LoginForm } from '../../input/LoginForm/LoginForm';
import { Footer } from '../../layout/Footer';
import { useStyles } from './LoginPage.styles';
import { REPORTS_PATH } from '../../../constants/routes';
import history from '../../../utils/history';
import storage from '../../../utils/storage';
import useIsDesktop from '../../../hooks/useIsDesktop/useIsDesktop';

export function LoginPage() {
  const location = useLocation();
  // Pairing may require fresh human authentication without first destroying
  // unrelated portal state. Ordinary /login keeps its existing redirect.
  const reauthenticate = new URLSearchParams(location.search).get('reauth') === 'tablet-management';
  const isDesktop = useIsDesktop();
  const classes = useStyles({ isDesktop });
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.user.isLoading);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (reauthenticate) return;
    const checkToken = async () => {
      const isAuthTokenPresent = await storage.get('user');

      if (user && isAuthTokenPresent) {
        history.replace(history.location?.state?.from || REPORTS_PATH);
      }
    };
    checkToken();
  }, [user, reauthenticate]);

  const onSubmit = (data) => {
    dispatch(signInRequest(data));
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={classes.rootcontainer}
      >
        <Card className={classes.card} variant="outlined">
          <CardContent className={classes.cardContent}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="stretch"
            >
              <Grid item xs={12}>
                <Grid container>
                  <Grid item lg>
                    <LoginForm onSubmit={onSubmit} isLoading={isLoading} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Footer />
    </>
  );
}
